import { useQuery } from '@tanstack/react-query'
import { FeatureDict, selectFeatureIncludes } from '@authed/selectors'
import { getCreativeClassifications } from '@global/api'
import { useAppSelector } from '@redux/hooks'

const KEY = 'creativeClassifications'

export const useCreativeClassifications = () => {
  const [CREATIVE_CLASSIFICATION_ENABLED = false] = useAppSelector(
    selectFeatureIncludes([FeatureDict.CREATIVE_CLASSIFICATION]),
  )
  return useQuery({
    queryKey: [KEY],
    queryFn: ({ signal }) => getCreativeClassifications({ signal }),
    enabled: CREATIVE_CLASSIFICATION_ENABLED,
    refetchOnWindowFocus: false,
    select: data => data.filter(d => d.categoryKey !== 'demographics'), // Removed from our set of supported AI classifiers.
  })
}
